import React from 'react';
import { Button } from '../components/Button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const MAX_VISIBLE = 5;

// Returns up to MAX_VISIBLE page numbers centered on the current page.
// Pulled out of the component so the render function has no branching of its own.
const getVisiblePages = (page, totalPages) => {
  const half = Math.floor(MAX_VISIBLE / 2);
  let start = Math.max(1, page - half);
  const end = Math.min(totalPages, start + MAX_VISIBLE - 1);
  start = Math.max(1, end - MAX_VISIBLE + 1);

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

const arrowButtonClass =
  'w-10 h-10 rounded-lg border border-border flex items-center justify-center text-muted hover:bg-primary hover:text-white hover:border-primary transition-all cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-muted';

const pageButtonClass = (isActive) =>
  `w-10 h-10 rounded-lg flex items-center justify-center font-bold cursor-pointer transition-all ${
    isActive
      ? 'bg-primary text-white'
      : 'border border-border text-muted hover:bg-primary hover:text-white hover:border-primary'
  }`;

const Pagination = ({ page, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const visiblePages = getVisiblePages(page, totalPages);

  return (
    <div className="flex justify-center mt-12 gap-2">
      <Button
        variant="primary"
        className={arrowButtonClass}
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
      >
        <ChevronLeft className="w-5 h-5" />
      </Button>

      {visiblePages.map((num) => (
        <Button
          key={num}
          variant="primary"
          className={pageButtonClass(num === page)}
          onClick={() => onPageChange(num)}
        >
          {num}
        </Button>
      ))}

      <Button
        variant="primary"
        className={arrowButtonClass}
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        <ChevronRight className="w-5 h-5" />
      </Button>
    </div>
  );
};

export default Pagination;